import Api from '@/api'
// import { isEmpty } from 'lodash'
// import Request from '@/models/Request'

export default {
  namespaced: true,

  state: {
    requests: [],
    request: null,
    fileRequest: null
  },

  mutations: {
    setRequests(state, requests) {
      state.requests = requests
    },

    clearRequests(state) {
      state.requests = []
    },

    setRequest(state, request) {
      state.request = request
    },

    clearRequest(state) {
      state.request = null
    },

    setFileRequest(state, fileRequest) {
      state.fileRequest = fileRequest
    },

    clearFileRequest(state, fileRequest) {
      state.fileRequest = null
    }
  },

  actions: {
    async getRequestedBy({ commit }, filters) {
      commit('clearRequests')

      if (filters) {
        await new Promise(async (resolve, reject) => {
          await Api.get(
            `file-requested-by?filter[status]=${filters.status.join()}&filter[user]=${
              filters.ownedBy
            }`
          )
            .then(res => {
              if (res.data) {
                commit('setRequests', res.data.data)

                resolve(res.data.data)
              }
            })
            .catch(err => {
              reject(err.response)
            })
        })
      } else {
        await new Promise(async (resolve, reject) => {
          await Api.get(`file-requested-by`)
            .then(res => {
              if (res.data) {
                commit('setRequests', res.data.data)

                resolve(res.data.data)
              }
            })
            .catch(err => {
              reject(err.response)
            })
        })
      }
    },

    async getRequestedTo({ commit }, filters) {
      commit('clearRequests')

      if (filters) {
        await new Promise(async (resolve, reject) => {
          await Api.get(
            `file-requested-to?filter[status]=${filters.status.join()}&filter[user]=${
              filters.ownedBy
            }`
          )
            .then(res => {
              if (res.data.data) {
                commit('setRequests', res.data.data)

                resolve(res.data.data)
              }
            })
            .catch(err => {
              reject(err.response)
            })
        })
      } else {
        await new Promise(async (resolve, reject) => {
          await Api.get(`file-requested-to`)
            .then(res => {
              if (res.data.data) {
                commit('setRequests', res.data.data)

                resolve(res.data.data)
              }
            })
            .catch(err => {
              reject(err.response)
            })
        })
      }
    },

    async getRequest({ commit }, id) {
      commit('clearRequest')

      await new Promise(async (resolve, reject) => {
        await Api.get(`file-request/${id}`)
          .then(res => {
            if (res.data.data) {
              commit('setRequest', res.data.data)

              resolve(res.data.data)
            }
          })
          .catch(err => {
            reject(err.response)
          })
      })
    },

    async getRequestByUser({ commit }, id) {
      commit('clearRequest')

      await new Promise(async (resolve, reject) => {
        await Api.get(`file-request-users/${id}`)
          .then(res => {
            if (res.data.data) {
              commit('setRequest', res.data.data)

              resolve(res.data.data)
            }
          })
          .catch(err => {
            reject(err.response)
          })
      })
    },

    async deleteRequest({ commit }, id) {
      await new Promise(async (resolve, reject) => {
        await Api.delete(`file-request/${id}`)
          .then(res => {
            commit('clearRequest')

            resolve(res.data)
          })
          .catch(err => {
            reject(err.response)
          })
      })
    },

    async fileRequestShare({ commit }, formData) {
      await new Promise(async (resolve, reject) => {
        await Api.post(`file-request/${formData.fileRequestId}/share`, formData)
          .then(res => {
            commit('clearRequest')

            resolve(res.data)
          })
          .catch(err => {
            reject(err.response)
          })
      })
    }
  },

  getters: {
    requests(state) {
      return state.requests
    },

    request(state) {
      return state.request
    },

    fileRequest(state) {
      return state.fileRequest
    }
  }
}
